/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';
import { navigateToUrl } from 'single-spa';
import { getLogger } from '@/shared/infrastructure/datadog';
import { useSearchParams } from 'react-router-dom';

const appUrl = process.env.APP_URL;

const CheckAuth = (props: any) => {
  const auth = useAuth();
  const [searchParams] = useSearchParams();

  const checkAuth = async () => {
    try {
      const extraParams: Record<string, string> = {};
      searchParams.forEach((value, key) => {
        extraParams[key] = value;
      });

      auth.signinRedirect({ extraQueryParams: extraParams });
    } catch (error) {
      getLogger().error(error);
      navigateToUrl(appUrl);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading) {
      checkAuth();
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.signinRedirect]);

  return <></>;
};

export default CheckAuth;
